<template>
  <div id="app">
    <AdminPendingTenants v-if="router.currentRoute === 'admin'" />
    <Landing
      v-else-if="!isLoggedIn && (router.currentRoute === 'dashboard' || router.currentRoute === 'about')"
      :landing-section="router.currentRoute === 'about' ? 'about' : 'showcase'"
      @auth-success="handleAuthSuccess"
    />
    <Home v-else :user="currentUser" @user-updated="updateCurrentUser" />
  </div>
</template>

<script>
import Home from './components/Home.vue'
import Landing from './components/Landing.vue'
import AdminPendingTenants from './components/AdminPendingTenants.vue'
import { router, navigateTo } from './router'
import {
  applyDefaultPageMeta,
  applyAboutPageMeta,
  applyAdminPageMeta
} from './utils/pageMeta'

export default {
  components: {
    Home,
    Landing,
    AdminPendingTenants
  },

  data() {
    return {
      isLoggedIn: false,
      currentUser: null,
      router: router
    }
  },

  mounted() {
    const userToken = localStorage.getItem('userToken')
    const user = localStorage.getItem('user')
    if (userToken && user) {
      this.currentUser = JSON.parse(user)
      this.isLoggedIn = true
      if (this.router.currentRoute === 'dashboard') {
        navigateTo('agent-dashboard')
      }
    }
    this.syncPublicHead()
  },

  watch: {
    'router.currentRoute'() {
      if (this.isLoggedIn && this.router.currentRoute === 'dashboard') {
        navigateTo('agent-dashboard')
      }
      this.syncPublicHead()
    },
    isLoggedIn() {
      this.syncPublicHead()
    }
  },

  methods: {
    /** Meta tags para visitante / admin (área logada trata em Home.vue) */
    syncPublicHead() {
      if (this.isLoggedIn) return

      const r = this.router.currentRoute
      if (r === 'admin') {
        applyAdminPageMeta()
        return
      }
      if (r === 'about') {
        applyAboutPageMeta()
        return
      }
      applyDefaultPageMeta()
    },

    handleAuthSuccess(data) {
      this.currentUser = data.user
      this.isLoggedIn = true
      navigateTo('agent-dashboard')
    },

    updateCurrentUser(user) {
      this.currentUser = user
      if (user) {
        localStorage.setItem('user', JSON.stringify(user))
      }
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  background-color: #f9fafb;
}
</style>
